import React, { useState } from "react";
import SiteImages from "../SiteImages/SiteImages";

import "./images.css";

export default function Images({ images, panel_placement, solar_edge }) {
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedImageUrl, setSelectedImageUrl] = useState(null);

  const handleSelectedImage = (e) => {
    setSelectedImage(e.target.src.replace(/[^a-z]/g, ""));
    setSelectedImageUrl(e.target.src);
  };

  return (
    <section className="container mt-4">
      <p className="d-flex justify-content-start align-items-center mb-3">
        <span className="bg-jungle-green circle-icon sm m-0">
          <i className="icon icon-camera text-light-blue"></i>
        </span>
        <span className="ml-3 font-weight-bold">Images</span>
      </p>
      {panel_placement && (
        <div className="text-center mt-5">
          <p className="text-left">
            <b>Panel Placement</b>
          </p>
          <div
            type="button"
            data-toggle="modal"
            data-target={`#${panel_placement.replace(/[^a-z]/g, "")}`}
            onClick={handleSelectedImage}
          >
            <img src={panel_placement} alt="panel_placement" width="80%" />
          </div>
        </div>
      )}
      {solar_edge && (
        <div className="text-center mt-5">
          <p className="text-left">
            <b>Solar Edge Design</b>
          </p>
          <div
            type="button"
            data-toggle="modal"
            data-target={`#${solar_edge.replace(/[^a-z]/g, "")}`}
            onClick={handleSelectedImage}
          >
            <img src={solar_edge} alt="solar_edge" width="80%" />
          </div>
        </div>
      )}
      {images && (
        <SiteImages images={images} handleSelectedImage={handleSelectedImage} />
      )}
      <div
        className="modal fade"
        id={selectedImage}
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-custom" role="document">
          <div className="modal-content" data-dismiss="modal">
            <div className="modal-body">
              <img src={selectedImageUrl} alt={selectedImage} width="100%" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
